<template>
  <div>
    <cancel-heading is-centered>Subscription Paused</cancel-heading>
    <cancel-content is-centered>Your Forefront account access and billing has been paused temporarily.</cancel-content>
    <cancel-icon/>
  </div>
</template>

<script>
import CancelHeading from "./components/CancelHeading.vue";
import CancelIcon from "./components/CancelIcon.vue";
import CancelContent from "./components/CancelContent.vue";

export default {
  name: "PauseConfirmation",
  components: {CancelContent, CancelIcon, CancelHeading}
}
</script>
